import React from 'react';
import PropTypes from 'prop-types';
import { t } from '../../../services/i18nService';

import OptionButton from './OptionButton';

const ResumePasswordButton = ({ clickHandler, a11yAttributes }) => {
    return (<OptionButton
        isMainAction
        iconClass="fa fa-unlock-alt fa-fw"
        clickHandler={clickHandler}
        title={t('options.resumeSeb')}
        a11yAttributes={a11yAttributes}
    />);
};

ResumePasswordButton.propTypes = {
    clickHandler: PropTypes.func.isRequired,
    a11yAttributes: PropTypes.object,
};

export default ResumePasswordButton;
